<template>
  <div class="pb-5">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <v-toolbar-title>
        <h1 class="headline font-weight-bold">Newsletter Subscriptions</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row
        v-if="showSearch"
        align="center"
        style="max-width: 300px;"
      >
        <v-text-field
          flat
          hide-details
          single-line
          label="Search email"
          class="hidden-sm-and-down"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>
      <v-btn
        class="ml-5"
        icon
        @click="showSearch = !showSearch"
      >
        <img
          src="@/assets/icons/search.svg"
          alt
        />
      </v-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mr-1"
            icon
            @click="exportList"
            v-on="on"
          >
            <v-icon color="success">{{ icons.export }}</v-icon>
          </v-btn>
        </template>
        <span>Export to Excel</span>
      </v-tooltip>
    </v-app-bar>

    <v-card flat class="mt-8 pt-8">
      <div class="ma-4 text-right">
        <v-chip class="mr-8">Total: {{ listMeta.total }}</v-chip>
      </div>

      <div
        class="pa-4"
        id="newsletter-subscription-list"
      >
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">First Name</th>
              <th class="text-left">Email</th>
              <th class="text-left">Added date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="subscription in subscriptions"
              :key="subscription.id"
            >
              <td>{{ subscription.first_name}}</td>
              <td>
                <text-highlight :queries="filter.search">{{ subscription.email }}</text-highlight>
              </td>
              <td>{{ subscription.addedDate }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-overlay
          absolute
          :value="loading"
          opacity="0.1"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
        </v-overlay>
      </div>

      <div class="py-5 d-flex justify-center">
        <small class="grey--text lighten-4">{{listMeta.from}}-{{listMeta.to}} of {{ listMeta.total | formatNumber}}</small>
      </div>
    </v-card>

    <div
      class="text-center mt-4"
      v-if="listMeta.last_page > 1"
    >
      <v-pagination
        @input="pageChanged"
        :value="listMeta.current_page"
        :length="listMeta.last_page"
        :total-visible="10"
        circle
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mdiDotsVertical, mdiUnfoldMoreHorizontal, mdiMagnify, mdiAccountCircleOutline, mdiChevronRight, mdiFileExcel } from '@mdi/js'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import debounce from 'lodash/debounce'
import TextHighlight from 'vue-text-highlight'

export default {
  name: 'NewsLetterPage',

  components: {
    AppBarNavIcon,
    TextHighlight
  },

  data () {
    return {
      loading: false,
      showSearch: false,
      showProfile: false,
      selectedProfile: null,
      downloading: false,
      filter: {
        search: ''
      },
      icons: {
        settings: mdiDotsVertical,
        sort: mdiUnfoldMoreHorizontal,
        search: mdiMagnify,
        view: mdiAccountCircleOutline,
        arrow: mdiChevronRight,
        export: mdiFileExcel
      }
    }
  },

  computed: {
    ...mapState({
      subscriptions: state => state.newsLetter.list,
      listMeta: state => state.newsLetter.listMeta
    })
  },

  methods: {
    ...mapActions({
      getNewsLetter: 'newsLetter/getNewsLetter',
      exportToExcel: 'newsLetter/exportToExcel'
    }),

    pageChanged (page) {
      this.fetchNewsLetter(page)
    },

    search: debounce(function () {
      this.fetchNewsLetter()
    }, 600),

    async fetchNewsLetter (page = 1) {
      let params = { page }
      if (this.filter.search) {
        params.search = this.filter.search
      }
      this.loading = true
      await this.getNewsLetter(params)
      this.loading = false
    },

    async exportList () {
      this.downloading = true
      await this.exportToExcel()
      this.downloading = false
    }
  },

  filters: {
    formatNumber (value) {
      return Number(value).toLocaleString()
    }
  },

  created () {
    this.fetchNewsLetter()
  }
}
</script>
